var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.iconImageClicked($event)}}},[_c('img',{class:_vm.small_icon ? 'small-icon' : 'ml-3 mb-2 image align-middle',attrs:{"src":_vm.image_src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }